export default function (context) {
    context.commit('form/clean');
}